<template>
  <a id="el" data-toggle="popover" :title="title" :data-content="content">
    <slot></slot>
  </a>
</template>

<style>
</style>

<script>
import $ from 'jquery'

export default {
  props: {
    title: {
      type: String,
      required: false
    },
    content: {
      type: String,
      required: false
    },
    placement: {
      type: String,
      required: false,
      default: 'auto'
    }
  },

  mounted () {
    this.$nextTick(() => {
      $(this.$el).popover({
        placement: this.placement
      })
    })
  },

  destroyed () {
    this.$nextTick(() => {
      $(this.$el).popover('destroy')
    })
  }
}
</script>



// WEBPACK FOOTER //
// BootstrapPopover.vue?5b8d0a32